var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/extenders/details-expand.js
var DetailsExpand = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "toggleContent", () => {
      const currentState = this.clickableElement.getAttribute("aria-expanded");
      if (currentState === "true") {
        this.clickableElement.setAttribute("aria-expanded", "false");
        if (this.dropdownListElement) {
          this.dropdownListElement.style.height = "0px";
        }
      } else {
        this.clickableElement.setAttribute("aria-expanded", "true");
        let closestSection = this.closest("section") || this.closest("footer");
        if (this.dropdownListElement) {
          this.dropdownListElement.style.height = this.dropdownListElement.style.maxHeight;
        }
        if (closestSection) {
          const allDetailsExpandElementsInSection = closestSection.querySelectorAll("details-expand");
          allDetailsExpandElementsInSection == null ? void 0 : allDetailsExpandElementsInSection.forEach((alternativeDetailsExpandElement) => {
            if (alternativeDetailsExpandElement === this)
              return null;
            const alternativedropdownListElement = alternativeDetailsExpandElement.querySelector("#dropdownList");
            if (alternativedropdownListElement) {
              alternativedropdownListElement.style.height = "0px";
            }
            alternativeDetailsExpandElement.clickableElement.setAttribute("aria-expanded", "false");
          });
        }
      }
    });
    const detailsExpandElement = this;
    this.clickableElement = detailsExpandElement.querySelector("[aria-controls]");
    this.clickableElement.addEventListener("click", this.toggleContent, true, { passive: false });
    this.dropdownListElement = detailsExpandElement.querySelector("#dropdownList");
    if (this.dropdownListElement) {
      const height = this.dropdownListElement.offsetHeight;
      this.dropdownListElement.style.maxHeight = `${height}px`;
      this.dropdownListElement.style.height = "0px";
    }
  }
};
if (customElements.get("details-expand") === void 0) {
  customElements.define("details-expand", DetailsExpand);
}
